import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface CarteiraVinculadaItem {
  id: number;
  seller_vinculado: number;
  fullname: string;
  codigo: string;
  ver_todos: boolean;
}
export interface CarteiraVinculadaLista {
  versao: string;
  vinculos: CarteiraVinculadaItem[];
}

@Injectable({ providedIn: 'root' })
export class CarteiraVinculadaService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  private get headers(): HttpHeaders {
    return new HttpHeaders({ 'X-Carteira-Token': localStorage.getItem('carteira_vinculada_token') || '' });
  }
  listar(sellerId: number): Observable<CarteiraVinculadaLista> {
    return this.http.get<CarteiraVinculadaLista>(`${this.baseUrl}api/VendedorCarteira/${sellerId}`, { headers: this.headers });
  }
  buscar(sellerId: number, busca: string): Observable<CarteiraVinculadaItem[]> {
    return this.http.get<CarteiraVinculadaItem[]>(`${this.baseUrl}api/VendedorCarteira/${sellerId}/disponiveis`,
      { headers: this.headers, params: { busca } });
  }
  salvar(sellerId: number, dados: CarteiraVinculadaLista): Observable<CarteiraVinculadaLista> {
    return this.http.put<CarteiraVinculadaLista>(`${this.baseUrl}api/VendedorCarteira/${sellerId}`, dados, { headers: this.headers });
  }
}
